import { configureStore } from '@reduxjs/toolkit';
import userStore from './modules/userStore'
import applyStore from './modules/pc/applyStore'
const store = configureStore({
    reducer: {
        user: userStore,
        // 其他模块的reducer...
        apply:applyStore
    }
})
export default store;